import React,{useState,useRef,useEffect} from "react";
import Form from "react-bootstrap/Form";

export default function SearchBox(props){
  useEffect(()=>{
    setSearchString(props.searchText);
  },[props.searchText]);

  const [searchString,setSearchString]=useState(props.searchText);
  let timer= useRef(null);
  const setString=(text)=>{
    //props.onEditing(text);
    setSearchString(text);
    clearTimeout(timer.current);
    timer.current=setTimeout(()=>props.onChange(text), 500);
  }

  return(
    <Form.Control
    onChange={(event) => {setString(event.target.value)}} type="text"
    style={{width: "100%",padding:8,fontSize:15,display: "inline"}}
    placeholder={"Filter by Name"} value={searchString}/>
  );
}
